import { InitialState, actionTypes } from './featureContext';

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_IS_LOADING:
      state.isLoading = action.state;
      break;
    case actionTypes.AUTHV3_FLAG:
      state.authV3Enabled = action.state;
      break;
    case actionTypes.LOCATION_BASED_ADMIN_FLAG:
      state.locationBasedAdmin = action.state;
      break;
    case actionTypes.VOICE_ACTIONS_FLAG:
      state.voiceActions = action.state;
      break;
    case actionTypes.PENDO_FLAG:
      state.pendoEnv = action.state;
      break;
    case actionTypes.IS_CLUSTERID_IN_BW_PATCHING:
      state.isClusterIdInBWPatching = action.state;
      break;
    case actionTypes.GLOBAL_NAVIGATION_FLAG:
      state.globalNavigation = action.state;
      break;
    case actionTypes.NEW_VOICEMAIL_FLAG:
      state.isNewVoicemail = action.state;
      break;
    case actionTypes.ACCOUNT_INFO_TAX_ID_FLAG:
      state.accountInfoTaxID = action.state;
      break;
    case actionTypes.ACCOUNT_INFO_TAX_ID_LINK_FLAG:
      state.accountInfoTaxIDLink = action.state;
      break;
    case actionTypes.SMS_USE_CASES:
      state.smsUseCases = action.state;
      break;
    case actionTypes.AUTOM8TLY:
      state.autom8tly = action.state;
      break;
    case actionTypes.SMS_CAMPAIGN_REGISTRY_GENERATE_CONTENT:
      state.smsEnablementGenerateContent = action.state;
      break;
    case actionTypes.BULK_IMPORTS_REARCHITECTURE:
      state.bulkImports = action.state;
      break;
    case actionTypes.BULK_IMPORTS_TEAMS:
      state.bulkImportsTeams = action.state;
      break;
    case actionTypes.BULK_IMPORTS_LOCATIONS:
      state.bulkImportsLocations = action.state;
      break;
    case actionTypes.TEAMS_SMS:
      state.teamsSMS = action.state;
      break;
    case actionTypes.TEAMS_SMS_LICENSING:
      state.teamsSMSLicensing = action.state;
      break;
    case actionTypes.PURCHASE_LICENSE_FLOW:
      state.purchaseLicenseFlow = action.state;
      break;
    case actionTypes.WELCOME_EMAIL:
      state.welcomeEmail = action.state;
      break;
    case actionTypes.CONNECT_FLAG:
      state.connect = action.state;
      break;
    case actionTypes.GLOBAL_NEXTIVACX_FLOW:
      state.globalNextivaCXFlowEnabled = action.state;
      break;
    case actionTypes.BULK_USERS_EDIT:
      state.bulkUsersEdit = action.state;
      break;
    case actionTypes.ALLOW_CX_PRIMARY_OWNER_REMOVAL:
      state.cxPrimaryOwnerRemoval = action.state;
      break;
    default:
      return InitialState;
  }
};
